// @flow
import React, { useState, useEffect, useCallback } from 'react'
import I18n from 'i18n-react'
import { pipe, pathOr, find } from 'ramda'
import Immutable from 'seamless-immutable'
import { connect } from 'react-redux'

import UserDataActions from '../../../Core/Redux/UserDataRedux'

import FieldForm from '../FieldForm'
import { getValueForPath } from '../../FilterFunctions'
import { selectCoverageCarValue } from '../../selectors/coverageCarValueSelector'

import type { FormValueType } from '../../Types/Values'

const carValuePillowContent = {
  fieldOrder: ['carValue'],
  fieldNames: {
    carValue: 'Cena vozidla (Kč)',
  },
}

const SupplementaryInsuranceCheck = (props) => {
  const {
    coverageCarValue,
    data,
    formData,
    id,
    miniAppData,
    onChangeFormData,
    specification,
    textMode,
    title,
    userDataSetValue,
  } = props
  const [internalSpecification, setInternalSpecification] = useState(null)
  const [carValueEnabled, setCarValueEnabled] = useState(false)
  const [dataInternal, setDataInternal] = useState({})
  const [validationErrors, setValidationErrors] = useState(Immutable({}))

  useEffect(() => {
    const vehicleType = getValueForPath(`userData.type`, 0, props.templateVariables) || 'car'
    const restrictedTypes = getValueForPath(`coverages.${specification.name}.restrictedTypes`, 0, props.resources) || []
    setInternalSpecification({
      name: specification.name,
      fields: [
        {
          name: 'limit',
          domain: {
            _type: 'int-enum-ref',
            resourceName: `coverages.${specification.name}.${
              restrictedTypes.includes(vehicleType) ? 'restricted' : 'default'
            }.limits`,
          },
          enabled: true,
          required: true,
        },
      ],
      types: [],
    })
  }, [specification.name])

  useEffect(() => {
    setCarValueEnabled(
      pipe(
        pathOr([], ['fields']),
        find((field) => field.name === 'carValue'),
        pathOr(false, ['enabled']),
      )(specification),
    )
  }, [specification])

  useEffect(() => {
    let newInternalData = Immutable({})
    if (carValueEnabled && ((data && data.carValue) || coverageCarValue)) {
      newInternalData = newInternalData.set('carValue', pathOr(coverageCarValue, ['carValue'], data))
    }
    if (typeof data === 'object') {
      newInternalData = newInternalData.set('limit', 1)
    }
    setDataInternal(newInternalData)
  }, [data, carValueEnabled, coverageCarValue])

  const handleOnClick = useCallback(() => {
    onChangeFormData(
      {
        [specification.name]: {},
      },
      [specification.name],
      true,
    )
  }, [specification.name])

  // not needed
  const changeFormData = () => {}

  const onChangeValue = (key: string, value: FormValueType, pathArray: Array<string>) => {
    let newData = Immutable(formData || {})
    if (!newData[specification.name]) {
      newData = newData.setIn([specification.name], data || {})
    }
    if (coverageCarValue && carValueEnabled) {
      newData = newData.setIn([specification.name, 'carValue'], coverageCarValue)
    }
    if (pathArray.includes('carValue') && value) {
      newData = newData.setIn([specification.name, 'carValue'], value)
      onChangeFormData(newData, [specification.name], !pathArray.includes('carValue'))
      setValidationErrors(Immutable({}))
      userDataSetValue(['cic', 'carValue'], value)
    } else {
      const validateObject = miniAppData.onQuoteValidate(false, newData)
      if (validateObject.isValid) {
        onChangeFormData(newData, [specification.name], true)
      } else {
        const carValueErrors = pathOr(undefined, [specification.name, 'carValue'], validateObject.errors)
        if (carValueErrors) {
          setValidationErrors(validationErrors.merge({ carValue: carValueErrors }))
        } else {
          console.error(validateObject)
        }
      }
    }
  }
  const vehicleType = getValueForPath(`userData.type`, 0, props.templateVariables) || 'car'
  const restrictedTypes = getValueForPath(`coverages.${specification.name}.restrictedTypes`, 0, props.resources) || []
  const resourcesValue = getValueForPath(
    `coverages.${specification.name}.${restrictedTypes.includes(vehicleType) ? 'restricted' : 'default'}.limits`,
    0,
    props.resources,
  )

  if (textMode) {
    return <span />
  }

  return (
    <div key={`${id}-row`}>
      {carValueEnabled && !coverageCarValue && (
        <div className="my-4">
          <FieldForm
            {...props}
            content={carValuePillowContent}
            data={dataInternal}
            onChangeFormData={changeFormData}
            onChangeValue={onChangeValue}
            pushIsPristine={false}
            showBlockTitle={false}
            validationErrors={validationErrors}
          />
        </div>
      )}
      <strong>{title}</strong>
      <div className="row my-2">
        <div className="col-4">
          <strong>{I18n.translate('components.supplementaryInsurance.limit')}</strong>
        </div>
        <div className="col-3">
          <strong>{I18n.translate('components.supplementaryInsurance.offer')}</strong>
        </div>
      </div>
      <hr className="border-0 border-sm-top" />
      {Array.isArray(resourcesValue) && resourcesValue.length > 0 && internalSpecification ? (
        <FieldForm
          {...props}
          data={dataInternal}
          onChangeFormData={changeFormData}
          onChangeValue={onChangeValue}
          showBlockTitle={false}
          specification={internalSpecification}
        />
      ) : typeof data === 'object' ? (
        <button className="btn btn-secondary disabled btn-block px-0" type="button">
          {I18n.translate('components.supplementaryInsurance.selected')}
        </button>
      ) : (
        <button className="btn btn-secondary btn-block px-0" onClick={handleOnClick} type="button" value={props.value}>
          {I18n.translate('components.supplementaryInsurance.select')}
        </button>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  coverageCarValue: selectCoverageCarValue(state),
})

const mapDispatchToProps = {
  userDataSetValue: UserDataActions.userDataSetValue,
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplementaryInsuranceCheck)
